import React, { useState } from 'react'

const SearchForm = ({ onSubmit, placeholder }) => {
    const [keyword, setKeyword] = useState('')
    return (
        <div className="search_bar_cont">
            <form onSubmit={e => onSubmit(e, keyword)}>
                <input
                    type="text"
                    placeholder={placeholder}
                    value={keyword}
                    onChange={e => setKeyword(e.target.value)}
                    size="120"
                    className="search_bar__input"
                />
                <button className="search_bar__submit">
                    <span className="search_bar__submit-label">Search</span>
                </button>
            </form>
        </div>
    )
}

export default SearchForm
